'use client';

import React from 'react';
import LeftBottomImg from '../../../public/images/prod_left_bottom.png';
import RightBottomImg from '../../../public/images/prod_right_bottom.png';
import HomeIntro from '@/assets/images/home_intro.png';
import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function Introduce() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();
  const styling = {
    backgroundImage: `url('${LeftBottomImg.src}'), url('${RightBottomImg.src}')`,
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundPosition: 'left bottom, right bottom',
    backgroundSize: '326px 236px,556px 386px'
  };

  const interestHref = `/talk-to-expert`;

  return (
    <>
      <div className="z-20 w-full h-fit bg-base-white flex flex-col items-center justify-center">
        <div className="w-full flex min-h-[calc(100%-84px)] relative flex-1 flex-col items-center h-full overflow-visible mt-[68px]">
          <div className="bg-gray-900 w-full h-[46px] flex items-center justify-center text-primaryInverse font-semibold text-md leading-xl">
            {t('home.early_access', {})}
          </div>
        </div>
      </div>
      <div>
        <div
          style={styling}
          className="justify-center w-full flex min-h-[calc(100%-84px)] bg-white relative pb-[188px] flex-1 flex-col items-center h-full overflow-visible">
          <div className="w-[1280px] flex flex-row justify-center pt-[76px] gap-[64px] overflow-visible">
            <div className="w-[630px] shrink-0 flex flex-col gap-[36px] mt-[48px] overflow-visible">
              <div className="flex flex-col flex-start items-start gap-5xl">
                <div className="font-display font-semibold text-5xl leading-19xl text-primary flex-grow-1 h-fit whitespace-normal break-keep">
                  {t('home.intro.title', {})}
                </div>
                <div className="font-body font-regular text-xl leading-3xl text-secondary break-keep">
                  {t('home.intro.description', {})}
                </div>
              </div>

              <a
                href={interestHref}
                className="h-[56px] bg-[#05a8fd] w-fit rounded-[8px] hover:bg-[#0497E4] active:bg-[#0686C8] px-[22px] py-[16px] font-display font-semibold text-lg leading-lg text-primaryInverse hover:no-underline">
                {t('talk_to_expert.capitalize', {})}
              </a>
            </div>
            <div className="grow-0 shrink-0 overflow-visible">
              <img
                src={HomeIntro.src}
                alt="Home Intro"
                className="w-[592px] h-[654px]"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
